import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Program } from 'app/types';

import { navigateTop } from 'common/utils';
import { newDetailUrl } from 'common/utils/conversions';

import styles from 'features/user/dashboard/pages/dashboard/Dashboard.module.scss';
import defaultIcon from 'assets/explore/icon-default.svg';

interface CompProps {
  program: Program;
}

const ProgramCard = ({ program }: CompProps): React.ReactElement => {
  const navigate = useNavigate();
  const newUrl = newDetailUrl('programs', program.id, program.name);

  return (
    <div
      className={`${styles.cardContainer}`}
      key={program.id}
      onClick={() => {
        navigate(newUrl), navigateTop();
      }}
    >
      <img
        src={`${program.photos?.[0]}`}
        className={`${styles.imageContainer}`}
        alt={`Photo of ${program.name}`}
      />
      <div className={styles.logoContainer}>
        <img className={styles.logo} src={program.logo || defaultIcon} />
      </div>
      <div className={styles.name}>{program.name}</div>
    </div>
  );
};

export default ProgramCard;
